import { Suspense } from "react";
import { Outlet, ScrollRestoration } from "react-router";
import { Footer, Navbar, Seo, Spinner } from "./components";
import {
  AboutUs,
  BotCourse,
  Courses,
  ContactUs,
  Gallery,
  HomeCoachingCourse,
  Homepage,
  OnlineCourse,
  ScratchCourse,
  ScreenFreeCourse,
} from "./pages";

const Layout = () => {
  return (
    <Suspense
      fallback={
        <div className="h-[50vh] flex justify-center items-center">
          <Spinner />
        </div>
      }
    >
      <Navbar />
      <Seo />
      <ScrollRestoration />
      <Outlet />
      <Footer />
    </Suspense>
  );
};

const NoMatch = () => {
  return (
    <div className="h-96 content-center text-center pt-20">
      <h2 className="text-3xl font-bold">Nothing to see here!</h2>
      <p className="mt-4">
        Go to{" "}
        <a href="/" className="text-blue-500 underline">
          Home
        </a>
      </p>
    </div>
  );
};

export const routes = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Homepage /> },
      { path: "about", element: <AboutUs /> },
      { path: "gallery", element: <Gallery /> },
      { path: "courses", element: <Courses /> },
      { path: "contact", element: <ContactUs /> },
      { path: "courses/screen-free", element: <ScreenFreeCourse /> },
      { path: "courses/online", element: <OnlineCourse /> },
      { path: "courses/scratch", element: <ScratchCourse /> },
      { path: "courses/bot-programming", element: <BotCourse /> },
      { path: "courses/home-coaching", element: <HomeCoachingCourse /> },
      { path: "*", element: <NoMatch /> },
    ],
  },
];

export const routePaths = [
  "/",
  "/about",
  "/gallery",
  "/courses",
  "/contact",
  "/courses/screen-free",
  "/courses/online",
  "/courses/scratch",
  "/courses/bot-programming",
  "/courses/home-coaching",
];
